export default __webpack_public_path__ + "static/media/giveaway-modal.2090229a.jpg";